(function () {
  function getCloseHandler(lightbox) {
    return function () {
      lightbox.removeAttribute('open');
      lightbox.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      var player = lightbox.querySelector('[data-video-page-player]');
      if (player) {
        while (player.firstChild) player.removeChild(player.firstChild);
      }
      if (lightbox._videoPageEscapeHandler) {
        document.removeEventListener('keydown', lightbox._videoPageEscapeHandler, true);
        lightbox._videoPageEscapeHandler = null;
      }
      lightbox._videoPageClose = null;
    };
  }

  function loadYouTubeAPI(callback) {
    if (window.YT && window.YT.Player) {
      callback();
      return;
    }
    if (window._videoPageYouTubeLoading) {
      window._videoPageYouTubeLoading.push(callback);
      return;
    }
    window._videoPageYouTubeLoading = [callback];
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(tag, firstScript);
    var prevReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (prevReady) prevReady();
      if (window._videoPageYouTubeLoading) {
        window._videoPageYouTubeLoading.forEach(function (cb) { cb(); });
        window._videoPageYouTubeLoading = [];
      }
    };
  }

  function loadVimeoAPI(callback) {
    if (window.Vimeo && window.Vimeo.Player) {
      callback();
      return;
    }
    if (window._videoPageVimeoLoading) {
      window._videoPageVimeoLoading.push(callback);
      return;
    }
    window._videoPageVimeoLoading = [callback];
    var script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.onload = function () {
      window._videoPageVimeoLoading.forEach(function (cb) { cb(); });
      window._videoPageVimeoLoading = [];
    };
    document.head.appendChild(script);
  }

  function init() {
    document.querySelectorAll('[data-video-page-trigger]').forEach(function (trigger) {
      if (trigger.dataset.videoPageInitialized) return;
      trigger.dataset.videoPageInitialized = 'true';

      var blockId = trigger.getAttribute('data-block-id');
      var section = trigger.closest('.video-page');
      if (!section) return;

      var lightbox = section.querySelector('.video-page__lightbox');
      var player = section.querySelector('[data-video-page-player]');
      var template = section.querySelector('[data-video-page-template="' + blockId + '"]');

      if (!lightbox || !player || !template) return;

      var close = getCloseHandler(lightbox);

      trigger.addEventListener('click', function () {
        window.pauseAllMedia && window.pauseAllMedia();

        while (player.firstChild) player.removeChild(player.firstChild);
        var iframeClone = template.content.cloneNode(true);
        player.appendChild(iframeClone);

        lightbox.hidden = false;
        lightbox.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');

        var closeBtn = lightbox.querySelector('.video-page__lightbox-close');
        if (closeBtn) closeBtn.focus();
        if (typeof trapFocus === 'function') {
          trapFocus(lightbox, closeBtn);
        }

        /* Close on Escape – use capture phase so we get the key even when focus is inside the iframe */
        function escapeHandler(e) {
          if (e.code !== 'Escape') return;
          if (!lightbox.hasAttribute('open')) return;
          e.preventDefault();
          e.stopPropagation();
          close();
        }
        lightbox._videoPageEscapeHandler = escapeHandler;
        document.addEventListener('keydown', escapeHandler, true);

        /* Close when video ends (YouTube or Vimeo) – store close on lightbox so callbacks never lose it */
        lightbox._videoPageClose = close;
        var iframe = player.querySelector('.js-youtube');
        if (iframe) {
          loadYouTubeAPI(function () {
            try {
              var ytPlayer = new window.YT.Player(iframe, {
                events: {
                  onReady: function (event) {
                    event.target.addEventListener('onStateChange', function (e) {
                      if (e.data === 0 && lightbox._videoPageClose) lightbox._videoPageClose();
                    });
                  }
                }
              });
            } catch (err) {}
          });
        } else {
          iframe = player.querySelector('.js-vimeo');
          if (iframe) {
            loadVimeoAPI(function () {
              try {
                var vimeoPlayer = new window.Vimeo.Player(iframe);
                vimeoPlayer.on('ended', function () {
                  if (lightbox._videoPageClose) lightbox._videoPageClose();
                });
              } catch (err) {}
            });
          }
        }
      });
    });

    document.querySelectorAll('[data-video-page-close]').forEach(function (btn) {
      if (btn.dataset.videoPageCloseInitialized) return;
      btn.dataset.videoPageCloseInitialized = 'true';

      var lightbox = btn.closest('.video-page__lightbox');
      if (!lightbox) return;

      var close = getCloseHandler(lightbox);

      btn.addEventListener('click', close);
      if (btn.classList.contains('video-page__lightbox-backdrop')) {
        btn.addEventListener('click', function (e) {
          if (e.target === btn) close();
        });
      }
    });

    document.querySelectorAll('.video-page__lightbox').forEach(function (lightbox) {
      if (lightbox.dataset.videoPageKeydownInit) return;
      lightbox.dataset.videoPageKeydownInit = 'true';

      lightbox.addEventListener('keydown', function (e) {
        if (e.code !== 'Escape') return;
        if (!lightbox.hasAttribute('open')) return;
        e.preventDefault();
        getCloseHandler(lightbox)();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
